import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { IoIosCheckmark as TickIcon } from 'react-icons/io';
import { createUseStyles } from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';

import { ZINDEX } from '../../constants';
import { toggleFilter } from '../../redux/actions';

const useStyles = createUseStyles({
  button: {
    '&.bottomleft': { bottom: 12, left: 12 },
    '&.bottomright': { bottom: 12, right: 12 },
    '&.hidden': { color: '#393939' },
    '&.hidden:hover': { color: '#FFAE49' },
    '&.topleft': { left: 12, top: 12 },
    '&.topright': { right: 12, top: 12 },
    '&:hover': { color: '#393939' },
    background: '#272727',
    borderRadius: 24,
    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.45)',
    color: '#FFAE49',
    composes: ['is-block', 'is-absolute', 'no-overflow'],
    height: 48,
    transition: 'color 0.3s, background 0.3s',
    width: 48,
    zIndex: ZINDEX.MAP_CONTROLS,
  },
  icon: {
    verticalAlign: 'middle',
  },
});

const CompletedButtonComponent = React.memo(({ position }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const filters = useSelector(_ => _.filters);
  const hidden = filters.includes('completed');

  const clickHandler = useCallback(
    (types, visible) => dispatch(toggleFilter(types, visible)),
    [dispatch]
  );

  return (
    <button
      className={classnames(classes.button, {
        bottomleft: position === 'bottomleft',
        bottomright: position === 'bottomright',
        hidden,
        topleft: position === 'topleft',
        topright: position === 'topright',
      })}
      type="button"
      onClick={() => clickHandler(['completed'], !hidden)}>
      <TickIcon className={classes.icon} size={42} />
    </button>
  );
});

CompletedButtonComponent.defaultProps = {
  position: 'bottomright',
};

CompletedButtonComponent.propTypes = {
  position: PropTypes.oneOf([
    'topleft',
    'bottomleft',
    'bottomright',
    'topright',
  ]),
};

CompletedButtonComponent.displayName = 'CompletedButtonComponent';

export default CompletedButtonComponent;
